/**
 * AIE-403: Single source of truth for objective-function-aware label copy.
 *
 * The optimizer supports two objective functions today (Sortino and Sharpe).
 * UI surfaces should render the label that matches the study's actual chosen
 * objective rather than hardcoding "Sortino" everywhere. Use these helpers at
 * any site that displays a per-study objective label.
 *
 * Legacy behavior: when the value is null/undefined (e.g. legacy studies whose
 * stored payload predates persistence of `objective_function`), default to
 * "Sortino" so existing UIs do not regress.
 */

export type ObjectiveFunction = "sortino" | "sharpe";

/**
 * Full label, e.g. for "Best Value (Sortino Ratio)" headers.
 */
export function objectiveLabel(
  fn: ObjectiveFunction | null | undefined,
): string {
  return fn === "sharpe" ? "Sharpe Ratio" : "Sortino Ratio";
}

/**
 * Short label, e.g. inline tags like "Best Value (Sortino)".
 */
export function objectiveShortLabel(
  fn: ObjectiveFunction | null | undefined,
): string {
  return fn === "sharpe" ? "Sharpe" : "Sortino";
}
